import { createFileRoute } from '@tanstack/react-router';

import { ClaimPage } from '@/pages/claim.page';

export const Route = createFileRoute('/_authenticated/contracts/$contractId/claim')({
  component: ClaimPage,
});
